<template>
  <ElTable
      ref="multipleTableRef"
      :data="tableData"
      :style="{width: '100%', marginTop: '16px',minHeight:tableData.length===0?'200':tableData.length-1<10?'max-content':'max-content'}"
      @selection-change="handleSelectionChange"
      @select="handleCheck"
      @select-all="handleClickSelectAll"
      @row-click="handle"
      v-loading="isLoading"
      id="sp_tables"
      :row-class-name="rowClass"
      :header-cell-class-name="cellClass"
      :cell-style="rowClassName"
      :header-cell-style="headerClassName"
      :row-key="row => row.id"
      :height="tableHeight"
      @cell-mouse-leave="clearVisiblePopover"
  >
    <!--    :row-key="row => row.id"-->
    <!--    :reserve-selection="true"-->
    <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true">
    </el-table-column>
    <el-table-column
        v-for="(item, index) in tableColumTitles"
        :key="item.value"
        :label="item.key"
        :prop="item.value"
        @render-header="handleTableRenderComplete"
        :width="handleColumnWidth(item)"
        :min-width="handleColumnMinWidth(item)"
    >
      <!--      :show-overflow-tooltip="item.value==='customerType'||item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
      <template #default="{ row, column, $index }" v-if="isSpTable">
        <template v-if="item.value === 'setting'">
          <slot name="settings" :row="{ row, column, $index }"></slot>
          <!--          <div style="display: flex">-->
          <router-link :to="'/email/customer/detail/' + row.id + '?type=1&tabKey=2&teamId='+teamId">
            <slot name="linkUserHistory"></slot>
          </router-link>
          <slot name="deleteCustomer" :row="row" :index="$index"/>
          <!--          </div>-->
        </template>
        <template v-else-if="item.value==='customerCode'">
          <div :ref="ref => (refMap[`${row.id}_code`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.id}_code`], row, 7)"
               v-if="getTextLength(row.customerCode) > sizeMaxNumber"
               class="over_normal"
               :key="row.customerCode">
            {{
              getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
            }}
          </div>
          <div v-else>
            {{ row.customerCode }}
          </div>
        </template>
        <template v-else-if="item.value === 'customerName'">
          <div :ref="el => setRef(el, row)"
               class="over_text"
               :key="row.customerName"
               @mouseenter="handleMouseEnter(row)"
               @click.native.stop="toDetail(row)">
            {{ row.customerName }}
          </div>
          <!--               @mouseover.stop="handleRef(refMap[`${row.id}_name`], row, 5)"-->
          <!--               v-if="getTextWidth(row.customerName)>= middleValueWidth"-->
          <!--          <div v-else class="over_text" @click.native.stop="toDetail(row)">-->
          <!--            {{ row.customerName }}-->
          <!--          </div>-->
        </template>
        <template v-else-if="item.value === 'customerType'">
          <div :ref="ref => (refMap[`${row.id}_customer_type`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.id}_customer_type`], row, 4)"
               v-if="getTextLength(row.customerType) > sizeMaxNumber"
               :key="row.customerType"
               class="over_normal">
            {{
              getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.customerType }}
          </div>
        </template>
        <template v-else-if="item.value==='customerOrigin'">
          <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
          <div :ref="ref => (refMap[`${row.id}_source`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"
               v-if="getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
               class="over_normal"
               :key="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name">
            <el-tag type="info" v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
              {{
                getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                    ? formatText(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                    : row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name
              }}
            </el-tag>
            <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
              +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '').length - 1 }}
            </template>
          </div>
          <div v-else class="over_normal">
            <el-tag type="info"
                    v-if="row?.mailCustomerOriginDetailVoList&&row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
              {{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name }}
            </el-tag>
            <template v-else></template>
            <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
              +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== "").length - 1 }}
            </template>
          </div>
        </template>
        <template v-else-if="item.value==='customerIntention'">
          <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
          <div :ref="ref => (refMap[`${row.id}_product`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 9)"
               v-if="getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
               class="over_normal"
               :key="row?.mailProductDetailVoList?.filter(it => it.name!=='')[0]?.name">
            <el-tag type="info" v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length!==0">
              {{
                getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                    ? formatText(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                    : row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name
              }}
            </el-tag>
            <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length>1">
              +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
            </template>
          </div>
          <div v-else class="over_normal">
            <el-tag type="info"
                    v-if="row?.mailProductDetailVoList&&row?.mailProductDetailVoList?.filter(it => it.name!=='').length!==0">
              {{ row?.mailProductDetailVoList?.filter(it => it.name !== "")[0]?.name }}
            </el-tag>
            <template v-else></template>
            <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !== '').length>1">
              +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
            </template>
          </div>
        </template>
        <template v-else-if="item.value==='createName'">
          <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"
               @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"
               v-if="getTextLength(row.createName) > sizeMaxNumber"
               class="over_normal"
               :key="row.createName">
            {{
              getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName
            }}
          </div>
          <div v-else class="over_normal">
            {{ row.createName }}
          </div>
        </template>
        <template v-else-if="item.value === 'customerLevel'">
          <el-button size="small" link type="primary" style="width: 100%; padding: 0;">
            {{ row.customerLevel }}
          </el-button>
        </template>
        <template v-else-if="item.value === 'maiContactVOList'">
          <div class="hover" v-if="row.maiContactVOList.length > 0">
            <!-- 触发内容1 -->
            <el-button link type="primary" :ref="ref => (refMap[row.id] = ref)"
                       @mouseover.stop="handleRef(refMap[row.id], row, 1)">
              {{ row.maiContactVOList.length }}
            </el-button>
          </div>
          <div v-else>
            <el-button link type="info">
              {{ row.maiContactVOList.length }}
            </el-button>
          </div>
        </template>
        <template v-else-if="item.value === 'mangerVOList'">
          <div class="hover" v-if="row.mangerVOList.length > 0">
            <!-- 触发内容1 -->
            <el-button link type="primary" :ref="ref => (refMap[row.customerCode] = ref)"
                       @mouseover.stop="handleRef(refMap[row.customerCode], row, 2)">
              {{ row.mangerVOList.length }}
            </el-button>
          </div>
          <template v-else>
            <el-button link type="info">
              {{ row.mangerVOList.length }}
            </el-button>
          </template>
        </template>
        <template v-else-if="item.value ==='zoneAddress'">
          <div style="cursor: pointer">
            <!-- 触发内容1 -->
            <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                      @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                      v-if="row?.zoneAddress"
                      :src="flag[row.zoneCode]"
                      style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                      lazy
            />
          </div>
        </template>
        <template v-else-if="item.value ==='lastTime'">
          <div>{{ row.lastTime }}</div>
        </template>
      </template>
    </el-table-column>
    <template #empty>
      <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
    </template>
  </ElTable>
  <!--  <div id="checkoutAll" ref="checkoutAll">-->
  <!--    <el-checkbox v-model="isSelectAll" :label="$t('tree.select.all')" size="large" @change="selectAll">-->
  <!--      {{ $t('common.customer.checkout.all', {count: isSelectAll ? totals : 0}) }}-->
  <!--    </el-checkbox>-->
  <!--  </div>-->
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      trigger="hover"
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      effect="dark"
      placement="right"
      :show-after="1200"
  >
    <template v-if="popoverType === 1">
      <div class="popover-content" v-html="
      '<div>' +
      activeItemElpopover.maiContactVOList
        .map((item) => `${item.contactName}<br/>`)
        .join('') +
      '</div>'
    "></div>
    </template>

    <template v-else-if="popoverType === 2">
      <div class="popover-content" v-html="
      '<div>' +
      activeItemElpopover.mangerVOList
        .map((item) => `${item.managerName}<br/>`)
        .join('') +
      '</div>'
    "></div>
    </template>

    <template v-else-if="popoverType === 3">
      <div class="popover-content">{{ activeItemElpopover.zoneAddress }}</div>
    </template>

    <template v-else-if="popoverType === 4">
      <div class="popover-content">{{ activeItemElpopover.customerType }}</div>
    </template>

    <template v-else-if="popoverType === 5">
      <div class="popover-content">{{ activeItemElpopover.customerName }}</div>
    </template>

    <template v-else-if="popoverType === 6">
      <div class="popover-content">
        {{ activeItemElpopover?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0].name }}
      </div>
    </template>

    <template v-else-if="popoverType === 7">
      <div class="popover-content">{{ activeItemElpopover.customerCode }}</div>
    </template>

    <template v-else-if="popoverType === 8">
      <div class="popover-content">{{ activeItemElpopover.createName }}</div>
    </template>
    <template v-else-if="popoverType === 9">
      <div class="popover-content">
        {{ activeItemElpopover?.mailProductDetailVoList?.filter(it => it.name !== '')[0].name }}
      </div>
    </template>
  </el-popover>

  <!-- 抽屉 -->
  <el-drawer
      size="530px"
      v-if="isShowDrawer"
      v-model="drawer2"
      style="padding: 15px 5px 15px 10px"
      :direction="direction"
  >
    <template #header>
      <div style="display: flex;align-items: center">
        <h4 style="color: rgba(0, 0, 0, .85);font-weight: 500;font-size: 16px;line-height: 22px;width: 410px">
          {{ activeItem.customerName }}
        </h4>
        <router-link
            :to="
            '/email/customer/detail/' +
            activeItem.id +
            '?tabKey=1&type=' +
            activeItem.type+'&teamId='+teamId
          "
            style="color: #409eff"
        >
          <el-button v-if="isShowEdit" link type="primary">{{ $t('common.edit') }}</el-button>
        </router-link>
      </div>
    </template>
    <template #default>
      <div v-loading="contactLoading">
        <div class="top_titles">
          <div>
            <div class="font_targert">{{ $t("common.customer.number") }}：{{ activeItem.customerCode }}</div>
            <div class="font_targert" style="margin: 10px 0px;">{{ $t("common_byinput") }}：{{
                activeItem.createName
              }}
            </div>
            <div class="font_targert" style="margin: 10px 0px;">{{
                $t("common.bybranch")
              }}：{{ activeItem.mangerVOList.map(item => item.managerName).join(',') }}
            </div>
            <div class="font_targert">
              {{ $t('sending.table.col.createTime') }}：{{ activeItem?.createTime }}
            </div>
          </div>
        </div>
        <div style="margin-top: 15px">
          <!-- table -->
          <div>
            <div class="customer_title">{{ $t('common.cds25') }}</div>
            <div class="small_box">
              <TableShows :key="String(activeItem?.id || '') + '_company'" :table-data="companyInfo"/>
            </div>
          </div>
          <div style="margin-top: 15px">
            <div class="customer_title">{{ $t('common.marketing.information') }}</div>
            <div class="small_box">
              <TableShows :key="String(activeItem?.id || '') + '_marketing'" :table-data="marketingInfo"/>
            </div>
          </div>
          <div style="margin-top: 15px">
            <div class="customer_title">{{ $t('common.contact') }}</div>
            <div
                class="small_box"
                v-for="(item, index) in contactInfo"
                :key="index"
            >
              <TableShows :key="String(activeItem?.id || '') + '_contact_' + index" :table-data="item"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script setup>
import {useStore} from "vuex";
import {
  ref,
  defineProps,
  computed,
  defineEmits, nextTick,
  onMounted, onUnmounted, watch, reactive
} from "vue";
import {useRoute, useRouter} from "vue-router";
import TableShows from "./TableShows.vue";
import flag from '@/assets/flag/index.js'
import {emptyUrl, POPOVER_DELAY_TIME, TIME_COUNT} from "@/utils/statusParams";
import {ElTable} from "element-plus";
import {flexWidth} from "@/utils/tableWidth";
import {debouncePlus, throttle} from "@/utils/mylodash";
import {i18n} from "@/lang"
import {formatText, getTextLength} from "@/utils/util";
import {auto} from "@popperjs/core";
import sessionStore from "@/utils/sessionStore";

const lang = computed(() => store.state.system.langLocal)
const route = useRoute()

const {isShowDrawer, isSpTable, tableData, totals, tableColumTitles, searchArea, isSelectAllTarget} = defineProps({
  tableData: {
    type: Array,
    default: () => [],
  },
  isShowPages: {
    type: Boolean,
    default: () => false,
  },
  isShowEdit: {
    type: Boolean,
    default: () => false,
  },
  tableColumTitles: {
    type: Array,
    default: () => [],
  },
  isShowDrawer: {
    type: Boolean,
    default: () => false,
  },
  isLoading: {
    type: Boolean,
    default: () => false,
  },
  isSpTable: {
    type: Boolean,
    default: () => true,
  },
  totals: {
    type: Number,
    default: 0,
  },
  searchArea: {
    type: Object,
    default: () => ({})
  },
  isSelectAllTarget: {
    type: Boolean,
    default: false
  }
});

const store = useStore();
const router = useRouter();

const drawer2 = ref(false);
const direction = ref("rtl");


const emit = defineEmits(["selections"]);

const teamId = computed(() => store.state.email.teamID);

const ruleForm = computed(() => store.state.customer.ruleForm);
const contactList = computed(() => store.state.customer.contactList);
const contactLoading = computed(() => store.state.customer.contactLoading);
const activeItem = computed(() => store.state.customer.ruleForm)
// 公司信息
const companyInfo = ref([]);
// 营销信息
const marketingInfo = ref([]);
// 联系人信息
const contactInfo = ref([]);


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)

// 选中的客户信息
const handle = async (item) => {
  if (item.sp) {
    return
  }
  if (isShowDrawer) {
    const {id} = item;
    console.log(item, 'item')
    await store.dispatch("customer/getQueryById", {customerId: id});
    drawer2.value = true;
    // 通过客户id查询客户信息
    sessionStore.set("customerId", id);
    // 整理表格数据
    if (ruleForm) {
      const {
        phoneWayList,
        setUpTime,
        economicNature,
        companyWebsite,
        companyAddress,
        zoneAddress,
        companyFax,
        emailWayList,
        companyRemark,
        // ----
        customerType,
        customerLevel,
        marketingRemark,
      } = ruleForm.value;
      console.log('dddddd', ruleForm.value)
      // 公司信息
      companyInfo.value = [
        {
          name: i18n.global.t("common.region.name"),
          value: zoneAddress,
        },
        {
          name: i18n.global.t("common.customer.source"),
          value: item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '') : '',
        },
        {
          name: i18n.global.t('common.establishment'), value: setUpTime
        },
        {
          name: i18n.global.t('common.economicnature'), value: economicNature
        },
        {
          name: i18n.global.t('common.cds6'),
          value:
              emailWayList.length !== 0 ? emailWayList.filter((item) => item.isDefault === 1)[0]?.content :
                  [],
        },
        {
          name: i18n.global.t('common.cds2'), value: companyAddress
        },
        {
          name: i18n.global.t("more.check.phone"),
          value: phoneWayList.length !== 0 ? phoneWayList.filter((item) => item.isDefault === 1)[0]?.content :
              [],
        },
        {
          name: i18n.global.t('common.faxnumber'), value:
          companyFax
        },
        {
          name: i18n.global.t('common.company.website'), value:
          companyWebsite
        },
        {
          name: i18n.global.t('other.remark'), value:
          companyRemark
        },
      ];
      // 营销信息
      marketingInfo.value = [
        {name: i18n.global.t('common.customer.type'), value: customerType},
        {name: i18n.global.t('common_customer_level'), value: customerLevel},
        {
          name: i18n.global.t('common.interest.product'),
          value: item?.mailProductDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailProductDetailVoList?.filter(item => item.name !== '') : ''
        },
        {name: i18n.global.t('create.customer.des'), value: marketingRemark},
      ];
      // 联系人详情
      try {
        await store.commit("customer/setContactPage", {
          page: 1,
          pageSize: 999,
        });
        await store.dispatch("customer/getContactList");
        // 清除数据干扰
        contactInfo.value = [];
        // 联系人详情
        contactInfo.value = contactList.value.map((item) => [
          {name: i18n.global.t('common.name'), value: item.name, isMain: item.isMain},
          {name: i18n.global.t('common.email'), value: item.email, isMain: item.isMain},
          {name: 'WhatsApp', value: item.whatsAppPhone},
        ]);
      } catch (e) {

      }
    }
  }
};

const handleSelectionChange = (value) => {
  // 选择被重新触发了
  // 清除全部勾选
  selectedData.value = value
  emit("selections", value);
};
const handleCheck = (value) => {
  if (isSelectAll.value) {
    isSelectAll.value = false;
  }
  emit("selectionChange", value);
  console.log(value, 'value')
}

const handleClickSelectAll = (value) => {
  emit("select-all", value)
}

const toDetail = (row) => {
  const newUrl = router.resolve('/email/customer/detail/' + row.id + '?type=' + row.type)
  openNewWindow(newUrl.href);
}
const openNewWindow = (url) => {
  window.open(url, "_blank");
};

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else if (columnIndex === 2) {
    return {textAlign: 'left', minWidth: "120px"}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 4 || columnIndex === 5) {
    return {
      'text-align': 'left',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  } else if (columnIndex === 2) {
    return {
      'text-align': 'left',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      minWidth: '120px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  } else {
    return {
      'text-align': 'center',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  }
}

const isSelectAll = ref(false)
const selectedData = ref([])
const multipleTableRef = ref(null)

const selectAll = (val) => {
  console.log(val, 'isSelectAll')
  val ? checkAllItem() : unCheckAllItem()
  emit("getSelect", val)
}

watch(() => isSelectAllTarget, (newVal) => {
  if (newVal) {
    isSelectAll.value = newVal;
  }
})

const checkAllItem = () => {
  multipleTableRef.value.toggleAllSelection()
}

const setIsSelectAll = (res) => {
  multipleTableRef.value.clearSelection()
  isSelectAll.value = res
}

const toggleRowSelection = (item, val) => {
  multipleTableRef.value.toggleRowSelection(item, val)
}
const getSelectionRows = () => {
  return multipleTableRef.value.getSelectionRows()
}

const setIsSelectSingle = (res) => {
  isSelectAll.value = res
}

const unCheckAllItem = () => {
  multipleTableRef.value.clearSelection()
}

const checkSelectable = (row, index) => {
  return !isSelectAll.value;
}

const cellClass = (row) => {
  if (row.columnIndex === 0) {
    return isSelectAll.value ? "disabledCheck" : "abledCheck"
  }
}


const handleTableRenderComplete = () => {
  const targetWidth = document.querySelectorAll('.el-table-column--selection')
  console.log('targetWidthoffsetWidth', targetWidth[0].offsetWidth)
}


const rowClass = ({row, column, rowIndex, columnIndex}) => {
  if (row.sp) {
    return 'fixed-row'
  }
}

const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}


const tableHeight = ref('max-content')

// const calcTableHeight = (height) => {
//   nextTick(() => {
//     const searchAreaDom = searchArea.getElement();
//     if (!searchAreaDom) return;
//
//     const style = window.getComputedStyle(searchAreaDom);
//     const marginTop = parseFloat(style.marginTop) || 0;
//     const marginBottom = parseFloat(style.marginBottom) || 0;
//
//     const totalSearchAreaHeight = searchAreaDom.offsetHeight + marginTop + marginBottom;
//
//     // 再加上你页面上其他固定的高度，比如顶部导航、padding等
//     const otherFixedHeight = 190; // 这里只加真正固定不变的，比如页头或分页器的高度
//     tableHeight.value = window.innerHeight - totalSearchAreaHeight - otherFixedHeight;
//     console.log('动态计算table高度', tableHeight.value, otherFixedHeight);
//   });
// }

// onMounted(() => {
//   calcTableHeight()
//   window.addEventListener('resize', calcTableHeight);
// })
//
// onUnmounted(() => {
//   window.removeEventListener('resize', calcTableHeight);
// })

// 设置 临界值 width
const middleValueWidth = ref(165)
// 字数大致限制
const sizeMaxNumber = ref(16)
const getHeaderTextWidth = (text) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    return 0;
  }

  context.font = "500 13px Microsoft YaHei";
  return Math.ceil(context.measureText(text || "").width);
}

const normalizeWidthValue = (value) => {
  if (value === undefined || value === null || value === '' || value === 'auto') {
    return 0;
  }

  const width = Number(value);
  return Number.isNaN(width) ? 0 : width;
}

const getHeaderMinWidth = (label, extraPadding = 0) => {
  const headerPadding = lang.value === 'zh-CN' ? 24 : 40;
  return getHeaderTextWidth(label) + headerPadding + extraPadding;
}

const getHeaderAwareWidth = (baseWidth, label, options = {}) => {
  const {minWidth = 0, extraPadding = 0} = options;
  return Math.max(normalizeWidthValue(baseWidth), getHeaderMinWidth(label, extraPadding), minWidth);
}

const handleClickSelectWidth = (item) => {
  if (item.value === "customerCode") {
    const baseWidth = flexWidth('customerCode', tableData, item.key) > middleValueWidth.value
        ? middleValueWidth.value
        : flexWidth('customerCode', tableData, item.key) + 20
    return getHeaderAwareWidth(baseWidth, item.key)
  } else if (item.value === "customerType") {
    const baseWidth = flexWidth('customerType', tableData, item.key) > middleValueWidth.value
        ? middleValueWidth.value
        : flexWidth('customerType', tableData, item.key) + 20
    return getHeaderAwareWidth(baseWidth, item.key)
  } else if (item.value === 'customerOrigin') {
    const baseWidth = flexWidth('customerOrigin', tableData, item.key) > middleValueWidth.value
        ? middleValueWidth.value
        : flexWidth('customerOrigin', tableData, item.key) + 65
    return getHeaderAwareWidth(baseWidth, item.key)
  } else if (item.value === 'customerIntention') {
    const baseWidth = flexWidth('customerIntention', tableData, item.key) > middleValueWidth.value
        ? middleValueWidth.value
        : flexWidth('customerIntention', tableData, item.key) + 65
    return getHeaderAwareWidth(baseWidth, item.key)
  } else if (item.value === 'createName') {
    const createNameWidth = flexWidth('createName', tableData, item.key)
    if (createNameWidth > middleValueWidth.value) {
      return getHeaderAwareWidth(middleValueWidth.value, item.key, {minWidth: 80})
    } else {
      if (createNameWidth < 80) {
        return getHeaderAwareWidth(80, item.key, {minWidth: 80})
      } else {
        return getHeaderAwareWidth(createNameWidth, item.key, {minWidth: 80})
      }
    }

  } else if (item.value === 'customerLevel') {
    return getHeaderAwareWidth(lang.value !== 'zh-CN' ? 120 : 80, item.key);
  } else if (item.value === 'maiContactVOList' || item.value === 'zoneAddress' || item.value === 'auditName' || item.value === 'userName' || item.value === 'mangerVOList') {
    return getHeaderAwareWidth(80, item.key);
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return getHeaderAwareWidth(150, item.key);
  } else if (item.value === 'auditStatus') {
    return getHeaderAwareWidth(120, item.key)
  } else if (item.value === 'setting') {
    return getHeaderAwareWidth(lang.value !== 'zh-CN' ? 180 : 120, item.key);
  } else {
    return undefined
  }
}

const handleClickSelectMinWidth = (item) => {
  if (item.value === "customerName") {
    return Math.max(120, getHeaderMinWidth(item.key));
  } else if (item.value === "customerType") {
    return Math.max(120, getHeaderMinWidth(item.key));
  } else {
    return getHeaderMinWidth(item.key);
  }
}

const handleColumnWidth = (item) => {
  return handleClickSelectWidth(item)
}

const handleColumnMinWidth = (item) => {
  if (handleClickSelectWidth(item) !== undefined) {
    return undefined
  }
  return handleClickSelectMinWidth(item)
}

const overflowMap = reactive({})

const setRef = (el, row) => {
  if (!el) return
  refMap[row.id] = el

  nextTick(() => {
    overflowMap[row.id] = Math.ceil(el.scrollWidth) >= Math.ceil(el.clientWidth)
  })
}

const handleMouseEnter = (row) => {
  if (overflowMap[row.id]) {
    handleRef(refMap[row.id], row, 5)
  }
}

defineExpose({
  checkAllItem,
  unCheckAllItem,
  selectAll,
  setIsSelectAll,
  setIsSelectSingle,
  toggleRowSelection,
  getSelectionRows,
  // calcTableHeight
})
</script>

<style lang="less" scoped>

.pages {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.top_titles {
  padding-bottom: 15px;
  border-bottom: 1px solid #ebebeb;
}

.font_targert {
  font-size: 14px;
  color: black;
}

.small_box {
  width: max-content;
  margin-top: 15px;
}

:deep(.el-drawer) {
  width: 530px;
}

:deep(.el-table th.gutter) {
  display: table-cell !important;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
  position: relative;
}

#sp_tables {
  position: relative;

  :deep(.el-table__header) {
    min-width: 100%;
  }

  :deep(.el-table__body) {
    min-width: 100%;
  }
}

:deep(.disabledCheck .el-checkbox__input) {
  display: none !important;
  padding: 0px !important;
}

:deep(.abledCheck .el-checkbox__input) {
  display: block !important;
  padding: 0px !important;
}

:deep(.disabledCheck) {
  padding: 0px !important;
}

:deep(.abledCheck) {
  padding: 0px !important;
}

.sp_item {
  transition: all .3s;
}

:deep(.el-table__inner-wrapper::before) {
  content: none !important;
  display: none !important;
}

.demo-image__lazy .el-image {
  display: block;
  min-height: 526px;
  margin-bottom: 10px;
}

.demo-image__lazy .el-image:last-child {
  margin-bottom: 0;
}

:deep(.el-table__body) {
  // 吸底
  .fixed-row {
    background: white;
    position: sticky;
    z-index: 9;
    bottom: 0;
    width: 100%;
    //border-top: 1px solid red;

    td {
      background: white;
    }

  }
}

:deep(.el-table-column--selection .cell) {
  width: 40px !important;
  display: flex;
  justify-content: center;
}

#checkoutAll {
  position: absolute;
  margin-top: 16px;

  :deep(.el-checkbox__input) {
    width: 60px !important;
    display: flex;
    justify-content: center;
  }

  :deep(.el-checkbox__label) {
    padding-left: 0px !important;
  }
}

:deep(.el-table__empty-block) {
  height: 200px !important;
}

.customer_title {
  font-size: 14px;
  font-weight: 500;
}

:deep(.el-table__header) {
  min-width: 100%;
}

:deep(.el-table__body) {
  min-width: 100%;
}

:deep(.el-table__header-wrapper th .cell) {
  white-space: nowrap !important;
  word-break: keep-all !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
